export const COMPANY_INFO = {
  name: 'Orcsys',
  website: 'https://innov.orcsys.fr',
  email: 'info@orcsys.fr',
  founderEmail: 'malik@orcsys.fr',
  bookingLink: 'https://innov.orcsys.fr/booking',
  phone: '+33 6 64 62 30 60',
  siret: '933 326 084 00011',
  address: '75 Rue de Paris, 75001 Paris, France',
  hours: {
    days: 'Lundi - Vendredi',
    time: '9h00 - 18h00'
  },
  collab: {
    apple: "https://apps.apple.com/fr/app/orcsys-collab/id6736762590?l=en-GB",
    google: "https://play.google.com/store/apps/details?id=com.orcsys.collab",
  },
  social: {
    facebook: 'https://www.facebook.com/profile.php?id=61575512038378',
    twitter: 'https://x.com/orcsysteam',
    instagram: '#',
    linkedin: 'https://www.linkedin.com/company/orcsys/',
    github: '#'
  }
} as const;

export const PROJECTS = [
  {
    id: "quickpic",
    title: "QuickPic",
    description: "Avec QuickPic, réalisez facilement vos photos d’identité officielles directement depuis votre smartphone. Grâce à l’intelligence artificielle et à une vérification par des experts, recevez une planche photo et un code Ephoto agréé ANTS en quelques minutes pour tous vos documents officiels.",
    video: "https://firebasestorage.googleapis.com/v0/b/collab-a3929.appspot.com/o/website%20media%2FQuickPic%2Fvideo.mp4?alt=media&token=b2d07858-aa87-456f-8767-8b4c7e028bb1",
    type: "mobile",
    link: "#",
    date: "2023",
    client: "QuickPic",
    industry: "Photographie",
    logo: "https://firebasestorage.googleapis.com/v0/b/quickpic-87f18.appspot.com/o/quick%20pic%20iOS%20logo.png?alt=media&token=4bd6b96a-5e62-44fc-960d-a1156ff28c3d",
    features: ["IA", "EPhoto Code", "Apple Pay", "Google Pay", "PayPal"],
    tags: ["Flutter", "Django", "Firebase"],
    themeColor: "from-blue-900/90 to-blue-800/90",
    bgPattern: "url('data:image/svg+xml,%3Csvg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\'%3E%3Cpath d='M54.627 0l.83.828-1.415 1.415L51.8 0h2.827z'/%3E%3C/svg%3E')",
    stores: {
      apple: "https://apps.apple.com/fr/app/quickpic-photo-didentit%C3%A9/id6473794068?l=en-GB",
      google: "https://play.google.com/store/apps/details?id=com.quickpic.app",
      web: null,
    }
  },
  {
    id: "lecoindine",
    title: "Lecoindine",
    description: "Lecoindine est votre marketplace locale pour acheter et vendre des articles neufs ou d’occasion. Profitez d’un commerce de proximité, proposez des offres, achetez en lots, et échangez directement grâce à la messagerie intégrée. Avec des options de livraison flexibles, Lecoindine valorise votre communauté.",
    video: "https://firebasestorage.googleapis.com/v0/b/collab-a3929.appspot.com/o/website%20media%2FLecoindine%2Fvideo.mp4?alt=media&token=d4098e6d-ccda-40bd-879b-62facf0f629e",
    type: "mobile",
    link: "#",
    date: "2023",
    client: "Lecoindine",
    industry: "Commerce",
    logo: "https://firebasestorage.googleapis.com/v0/b/lecoindine-f0b1e.appspot.com/o/lecoindine%20app%20logo.png?alt=media&token=8ffabbe3-5fb8-431b-a0db-d6f94146c61d",
    features: ["Ecommerce", "C2C", "Messagerie", "Livraison"],
    themeColor: "from-teal-900/90 to-teal-800/90",
    bgPattern: "url('data:image/svg+xml,%3Csvg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\'%3E%3Cpath d='M54.627 0l.83.828-1.415 1.415L51.8 0h2.827z'/%3E%3C/svg%3E')",
    background: "https://unsplash.com/photos/c4pbb7yNM2c/download?ixid=M3wxMjA3fDB8MXxzZWFyY2h8MTV8fHNob3BwaW5nfGVufDB8fHx8MTczMTY0NDY1N3ww&force=true", // Add background image here
    stores: {
      apple: "https://apps.apple.com/fr/app/lecoindine-le-march%C3%A9-%C3%A9thique/id6476780044?l=en-GB",
      google: "https://play.google.com/store/apps/details?id=com.orcsys.lecoindine",
      web: null,
    },
  },
  {
    id: "lecoindine-web",
    title: "Lecoindine (Web)",
    description: "Lecoindine est une marketplace locale pour acheter et vendre des articles neufs ou d'occasion. Profitez d'un commerce de proximité avec messagerie intégrée et options de livraison flexibles.",
    video: "https://firebasestorage.googleapis.com/v0/b/collab-a3929.appspot.com/o/website%20media%2FLecoindine%2Fvideoweb.mp4?alt=media&token=35210cf3-632f-451f-9907-6017924313ad",
    type: "web",
    link: "#",
    date: "2023",
    client: "Lecoindine",
    industry: "Commerce",
    logo: "https://firebasestorage.googleapis.com/v0/b/lecoindine-f0b1e.appspot.com/o/lecoindine%20app%20logo.png?alt=media&token=8ffabbe3-5fb8-431b-a0db-d6f94146c61d",
    features: ["Ecommerce", "C2C", "Messagerie", "Livraison"],
    themeColor: "from-teal-900/90 to-teal-800/90",
    bgPattern: "url('data:image/svg+xml,%3Csvg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\'%3E%3Cpath d='M54.627 0l.83.828-1.415 1.415L51.8 0h2.827z'/%3E%3C/svg%3E')",
    background: "https://unsplash.com/photos/c4pbb7yNM2c/download?ixid=M3wxMjA3fDB8MXxzZWFyY2h8MTV8fHNob3BwaW5nfGVufDB8fHx8MTczMTY0NDY1N3ww&force=true", // Add background image here
    stores: {
      web: "https://lecoindine.com",
    },
  },
  {
    "id": "pumpy-family-life",
    "title": "Pumpy Family Life",
    "description": "Pumpy Family Life est votre plateforme  pour trouver des hébergements et services dédiés aux familles. Réservez des logements, explorez un annuaire de services locaux, découvrez des offres d'emploi et connectez-vous avec une communauté bienveillante.",
    "video": "https://firebasestorage.googleapis.com/v0/b/collab-a3929.appspot.com/o/website%20media%2FPumpy%20Family%20Life%2Fpumpy.mov?alt=media&token=e8ab50ff-2310-4d89-9652-817e63998345",
    "type": "web",
    "link": "https://pumpyfamilylife.com",
    "date": "2025",
    "client": "Pumpy Family Life",
    "industry": "Voyage",
    "logo": null,
    "features": ["Hébergements", "Annuaire", "Offres d'emploi", "Messagerie"],
    "themeColor": "from-sand-800/90 to-sand-700/90",
    "bgPattern": "url('data:image/svg+xml,%3Csvg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\'%3E%3Cpath d='M54.627 0l.83.828-1.415 1.415L51.8 0h2.827z'/%3E%3C/svg%3E')",
    "background": null,
    "stores": {
      "apple": null,
      "google": null,
      "web": "https://pumpyfamilylife.com"
    }
  },
  {
    "id": "espace-membre",
    "title": "Espace membre",
    "description": "Plateforme web complète de gestion d'association/de clubs qui centralise l'organisation des sessions, la collecte de thèmes, la gestion des sondages multi-questions, et la distribution de ressources documentaires.",
    "video": "https://firebasestorage.googleapis.com/v0/b/collab-a3929.appspot.com/o/website%20media%2FManssuétudes%2Fmanssu.mov?alt=media&token=188b0344-8c5a-48f8-8bae-4c92a0e01cfb",
    "type": "web",
    "date": "2025",
    "client": "Manssuétude",
    "industry": "Clubs",
    "logo": null,
    "features": ["Dashboard", "Sondages Multi-Questions", "Ressources Documentaires", "Thèmes", "Feedback"],
    "themeColor": "from-red-600/90 to-orange-500/90",
    "bgPattern": "url('data:image/svg+xml,%3Csvg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\'%3E%3Cpath d='M54.627 0l.83.828-1.415 1.415L51.8 0h2.827z'/%3E%3C/svg%3E')",
    "background": "https://unsplash.com/photos/Q1p7bh3SHj8/download?ixid=M3wxMjA3fDB8MXxzZWFyY2h8NXx8Y29tbXVuaXR5fGVufDB8fHx8MTczMTY0NDY1N3ww&force=true",
    "stores": {
      "apple": null,
      "google": null,
    }
  },
  {
    id: "influlink",
    title: "Influlink",
    description: "Influlink connecte les influenceurs aux entreprises pour booster leur visibilité en ligne. Les micro et nano-influenceurs bénéficient d’avantages exclusifs dans des lieux de leur choix, tandis que les entreprises accèdent à une publicité efficace et abordable.",
    video: "https://firebasestorage.googleapis.com/v0/b/collab-a3929.appspot.com/o/website%20media%2FInflulink%2Fvideo.mp4?alt=media&token=2248da1d-2897-421b-9e34-9cae98d2c458",
    type: "mobile",
    link: "#",
    date: "2024",
    client: "Influlink",
    industry: "Marketing",
    features: ["Lifestyle", "Prélèvement automatique", "Carte intégrée", "QR Code"],
    logo: "https://firebasestorage.googleapis.com/v0/b/influlink-a6808.appspot.com/o/influlink-logo.png?alt=media&token=81f3e618-ff33-42ce-8c2c-9d6a6666e20a",
    themeColor: "from-purple-950/90 to-purple-900/90",
    bgPattern: "url('data:image/svg+xml,%3Csvg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\'%3E%3Cpath d='M54.627 0l.83.828-1.415 1.415L51.8 0h2.827z'/%3E%3C/svg%3E')",
    background: "https://unsplash.com/photos/MqmfnpsjQrw/download?ixid=M3wxMjA3fDB8MXxzZWFyY2h8NDd8fGhpZ2glMjBlbmR8ZW58MHx8fHwxNzMxNzAwMjYwfDA&force=true", // Add background image here
    stores: {
      apple: "https://apps.apple.com/fr/app/influlink-exp%C3%A9riences-vip/id6624303854?l=en-GB",
      google: "https://play.google.com/store/apps/details?id=com.orcsys.app.influlink",
      web: null,
    }
  },
  {
    id: "collab",
    title: "Collab",
    description: "Collab est l’application client d’Orcsys, conçue pour suivre l’avancement de vos projets en temps réel. Communiquez efficacement sur les bugs, centralisez vos données, et accédez aux statistiques clés de votre application, le tout au même endroit.",
    video: "https://firebasestorage.googleapis.com/v0/b/collab-a3929.appspot.com/o/website%20media%2FCollab%2Fvideo.mp4?alt=media&token=dde9f8a4-d75e-465a-a8a9-bb3737ba60d0",
    type: "mobile",
    link: "#",
    date: "2024",
    client: "Orcsys",
    industry: "Productivité",
    features: ["Productivité", "Messagerie","Statistiques"],
    logo: "https://firebasestorage.googleapis.com/v0/b/collab-a3929.appspot.com/o/app-logo.png?alt=media&token=d5992453-c8da-4d33-9e32-153d87d5ccef",
    themeColor: "from-emerald-950/90 to-emerald-900/90",
    bgPattern: "url('data:image/svg+xml,%3Csvg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\'%3E%3Cpath d='M54.627 0l.83.828-1.415 1.415L51.8 0h2.827z'/%3E%3C/svg%3E')",
    background: "https://unsplash.com/photos/MqmfnpsjQrw/download?ixid=M3wxMjA3fDB8MXxzZWFyY2h8NDd8fGhpZ2glMjBlbmR8ZW58MHx8fHwxNzMxNzAwMjYwfDA&force=true", // Add background image here
    stores: {
      apple: "https://apps.apple.com/fr/app/orcsys-collab/id6736762590?l=en-GB",
      google: "https://play.google.com/store/apps/details?id=com.orcsys.collab",
      web: null,
    }
  },
  // {
  //   id: "axemedia",
  //   title: "Axe Media",
  //   description: "Axe Media est un média moderne qui offre des contenus informatifs et pertinents sur l'actualité camerounaise sur les réseaux sociaux. Ils proposent différents formats adaptés aux nouveaux modes de consommation de l'information, notamment les vidéos, le storytelling, les récapitulatifs d'actualités et bien plus encore.",
  //   video: "https://firebasestorage.googleapis.com/v0/b/collab-a3929.appspot.com/o/website%20media%2FAxe%20Media%2Faxemediavid.mp4?alt=media&token=43f32896-f750-4574-bfa7-1d3c3a761c0c",
  //   type: "web",
  //   link: "#",
  //   date: "2025",
  //   client: "Axe Media",
  //   industry: "Média",
  //   logo: "https://www.axemedia.net/favicon.png",
  //   features: ["Journalisme", "Vitrine", "Référencement"],
  //   themeColor: "from-[#3498DB] to-[#2C3E50]",
  //   bgPattern: "url('data:image/svg+xml,%3Csvg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\'%3E%3Cpath d='M54.627 0l.83.828-1.415 1.415L51.8 0h2.827z'/%3E%3C/svg%3E')",
  //   background: "https://unsplash.com/photos/MqmfnpsjQrw/download?ixid=M3wxMjA3fDB8MXxzZWFyY2h8NDd8fGhpZ2glMjBlbmR8ZW58MHx8fHwxNzMxNzAwMjYwfDA&force=true", // Add background image here
  //   stores: {
  //     web: "https://axemedia.net",
  //   },
  // },
  {
    id: "acimar",
    title: "Acimar - Agent de trading automatique",
    description: "Acimar est un bot de trading qui permet d'automatiser vos trades et d'analyser vos positions en toute sécurité selon vos signaux. Le bot est entièrement personnalisable et peut être utilisé sur n'importe quel broker (Binance, Interactive Brokers, etc.).",
    video: "https://firebasestorage.googleapis.com/v0/b/collab-a3929.appspot.com/o/website%20media%2FAI%20Trader%2Ftrade.mp4?alt=media&token=2c2e5183-866d-43a2-a017-e5d888dfcead",
    type: "web",
    link: "#",
    date: "2025",
    client: "Acimar",
    industry: "Finance",
    features: ["Trading", "Automatique", "Personnalisable"],
    logo: undefined,
    themeColor: "from-[#3B82F6]/90 to-[#2C3E50]/90",
    bgPattern: "url('data:image/svg+xml,%3Csvg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\'%3E%3Cpath d='M54.627 0l.83.828-1.415 1.415L51.8 0h2.827z'/%3E%3C/svg%3E')",
    background: "https://unsplash.com/photos/MqmfnpsjQrw/download?ixid=M3wxMjA3fDB8MXxzZWFyY2h8NDd8fGhpZ2glMjBlbmR8ZW58MHx8fHwxNzMxNzAwMjYwfDA&force=true", // Add background image here
  },
  {
    id: "esbabi",
    title: "'esbabi",
    description: "Esbabi est une application de rencontre en Europe. Préservez votre intimité grâce à un système innovant qui masque vos photos et votre identité jusqu’à ce qu’un match soit établi. Concentrez-vous sur ce qui compte vraiment pour trouver votre moitié.",
    video: "https://firebasestorage.googleapis.com/v0/b/collab-a3929.appspot.com/o/website%20media%2FEsbabi%2Fvideo.mp4?alt=media&token=3b6740fe-8ec9-43dc-be30-476f6fa0a3d9",
    type: "mobile",
    link: "#",
    date: "2024",
    client: "Esbabi",
    industry: "Social",
    features: ["Rencontre", "Souscription", "Messagerie"],
    logo: "https://firebasestorage.googleapis.com/v0/b/esbabi-4055c.appspot.com/o/app%20logo.png?alt=media&token=0e0c237b-aa41-4a21-a1c4-a05e219344a3",
    themeColor: "from-rose-950/90 to-rose-900/90",
    bgPattern: "url('data:image/svg+xml,%3Csvg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\'%3E%3Cpath d='M54.627 0l.83.828-1.415 1.415L51.8 0h2.827z'/%3E%3C/svg%3E')",
    background: "https://unsplash.com/photos/MqmfnpsjQrw/download?ixid=M3wxMjA3fDB8MXxzZWFyY2h8NDd8fGhpZ2glMjBlbmR8ZW58MHx8fHwxNzMxNzAwMjYwfDA&force=true", // Add background image here
    stores: {
    }
  },
];